<div class="container">
  <app-tabs>
    <app-tab
      *ngFor="let tab of data; let i = index"
      [tabTitle]="tab.title"
      [active]="i === 0"
    >
      <div class="products__grid">
        <div *ngFor="let item of tab.products" class="slide">
          <app-b2b-product-card
            [item]="item"
            [lang]="lang"
          ></app-b2b-product-card>
        </div>
      </div>
      <ngx-slick-carousel class="products__carousel" [config]="slideConfig">
        <div ngxSlickItem *ngFor="let item of tab.products" class="slide">
          <app-b2b-product-card
            [item]="item"
            [lang]="lang"
          ></app-b2b-product-card>
        </div>
      </ngx-slick-carousel>
    </app-tab>
  </app-tabs>
</div>
